<template>
  <div>
    <div
      v-if="!isLoading && lots.length"
      class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless-bottom has-background-white is-border-top is-border-left is-border-right is-multiline">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
          <div>
            <input
              id="security_deposit"
              v-model="displayDetails"
              name="security_deposit"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="security_deposit"
              style="font-size: 12.5px"
              class="">Afficher le détail des lots</label>
          </div>
        </div>
      </div>
      <div
        v-if="isAdmin && isPromoteur && isAmen && isProgramView"
        class="column">
        <div
          class="column is-narrow is_right is-border-left is-hoverhable"
          slot="before-actions"
          @mouseenter="displaySort = true"
          @mouseleave="displaySort = false">
          <a
            @click="exportAllLot"
            class=""
            :class="displaySort ? 'has-text-primary' : 'has-text-draft'">
            <span>Exporter données</span>
          </a>
        </div>
      </div>
    </div>
    <spinner-round
      v-if="isLoading"
      :is-loading="isLoading" />
    <table-controls-vue
      :has-sticky="true"
      v-if="!isLoading && lots.length"
      class="is-border">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <columns-toggles
                :entries="columnsList"
                :source="columns"
                @update="updateColumns"></columns-toggles>
            </th>
            <th class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('ref', $event)"
                sort-id="ref"
                :sort="sortBy.ref"
                label="Lot"></sortable>
              <span v-else>
                Lot
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="!isProgramView && showColumn('program__name')"
              class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('program__name', $event)"
                sort-id="program__name"
                :sort="sortBy['program__name']"
                label="Programme"></sortable>
              <span v-else>
                Programme
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('promoteur__name') && isAdmin && isDistributeur"
              class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('promoteur__name', $event)"
                sort-id="promoteur__name"
                :sort="sortBy['promoteur__name']"
                label="Promoteur"></sortable>
              <span v-else>
                Promoteur
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="!isProgramView && showColumn('address__zip_code')"
              class="is-groupcols-1a">
              <span>Code Postal</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="!isProgramView && showColumn('address__city')"
              class="is-groupcols-1a">
              <span>Ville</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('nature')"
              class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('nature', $event)"
                :sort="sortBy.nature"
                label="Nature"></sortable>
              <span v-else>
                Nature
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('operation_type')"
              class="is-nowrap is-groupcols-1a">
              <span>Type d'op</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a"
              v-if="showColumn('lot_type')">
              <span>Type</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a"
              v-if="showColumn('lot_subtype')">
              <span>Caractéristiques</span>
              <div class="deco"></div>
            </th>
            <th
              class="is-groupcols-1a"
              v-if="!isParking && showColumn('surface')">
              <sortable
                v-if="showSort"
                @sort="sort('surface', $event)"
                :sort="sortBy.surface"
                label="Surface"></sortable>
              <span v-else>
                Surface
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('tranche')"
              class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('tranche', $event)"
                :sort="sortBy.tranche"
                label="Tranche"></sortable>
              <span v-else>Tranche</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('building')"
              class="is-groupcols-1a">
              <span>Bâtiment</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('floor') && !isParking"
              class="is-groupcols-1a">
              <sortable
                v-if="showSort"
                @sort="sort('floor', $event)"
                :sort="sortBy.floor"
                label="Étage"></sortable>
              <span v-else>
                Étage
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('exposures') && !isParking"
              class="is-groupcols-1a">
              <span>Orientation</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('parking') && !isParking"
              class="is-groupcols-1a">
              <span>Parking</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('sale_price_ht')"
              class="is-nowrap is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('sale_price_ht', $event)"
                :sort="sortBy.sale_price_ht"
                label="Prix HT"></sortable>
              <span v-else>
                Prix HT
              </span>
              <div class="deco"></div>
            </th>
            <th class="is-nowrap is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('sale_price_ttc', $event)"
                :sort="sortBy.sale_price_ttc"
                label="Prix TTC"></sortable>
              <span v-else>
                Prix TTC
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('rent') && !isParking"
              class="is-nowrap is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('rent', $event)"
                :sort="sortBy.rent"
                label="Loyer HC"></sortable>
              <span v-else>
                Loyer HC
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('capped_rent')"
              class="is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('capped_rent', $event)"
                :sort="sortBy.capped_rent"
                label="Loyer plafonné"></sortable>
              <span v-else>
                Loyer plafonné
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="isAdmin && showColumn('rent')"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('rent', $event)"
                :sort="sortBy.rent"
                label="Loyer marché"></sortable>
              <span v-else>
                Loyer marché
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('tax_dispositifs') && !isParking"
              class="is-groupcols-2a">
              <span>Dispositif(s)</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('profitability') && !isParking"
              class="is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('profitability', $event)"
                :sort="sortBy.profitability"
                label="Rentabilité"></sortable>
              <span v-else>
                Rentabilité
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('capped_profitability') && !isParking"
              class="is-groupcols-2a">
              <sortable
                v-if="showSort"
                @sort="sort('capped_profitability', $event)"
                :sort="sortBy.capped_profitability"
                label="Rentabilité plafonnée"></sortable>
              <span v-else>
                Rentabilité plafonnée
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('date_livraison') && !isLotView && !isProgramView"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('date_livraison', $event)"
                :sort="sortBy.date_livraison"
                label="Livraison"></sortable>
              <span v-else>
                Livraison
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="showColumn('date_actabilite') && !isLotView && !isProgramView"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('date_actabilite', $event)"
                :sort="sortBy.date_actabilite"
                label="Actabilité"></sortable>
              <span v-else>
                Actabilité
              </span>
              <div class="deco"></div>
            </th>
            <th
              v-if="isAdmin && showColumn('created_on')"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('created_on', $event)"
                :sort="sortBy.created_on"
                label="Création"></sortable>
              <span v-else>
                Création
              </span>
              <div class="deco"></div>
            </th>
            <!-- <th
              v-if="isAdmin && showColumn('rent')"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('rent', $event)"
                :sort="sortBy.rent"
                label="Loyer marché"></sortable>
              <span v-else>
                Loyer marché
              </span>
              <div class="deco"></div>
            </th> -->
            <th
              v-if="(isAdmin || isManagerPlus) && showColumn('options')"
              class="is-groupcols-3a">
              <span>Options</span>
              <div class="deco"></div>
            </th>
            <th
              v-if="isAdmin && showColumn('sales_mode')"
              class="is-groupcols-3a">
              <sortable
                v-if="showSort"
                @sort="sort('sales_mode', $event)"
                :sort="sortBy.sales_mode"
                label="Mode de vente"></sortable>
              <span v-else>
                Mode de vente
              </span>
              <div class="deco"></div>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tr>
          <td
            colspan="24"
            style="padding: 0"
            v-if="multiselection && ['LotList'].includes($route.name)">
            <div
              class="is-flex is-nowrap is-align-items-center container_select_multiple_lotlist">
              <a
                :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                class="select_multiple_lotlist"
                @click="$store.commit('selectAllMultiselectionItems')">
                <i
                  style="font-size: 17px; padding: 0px 19px"
                  class="far fa-check-double"></i>
                <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
              </a>
            </div>
          </td>
        </tr>
        <lot-row
          v-for="(l, i) in lots"
          :id="'e' + l.pk"
          :key="l.pk + l.status"
          :source-lot="l"
          :index="i"
          :display-details="displayDetails"
          :columns-lot-row="columns"
          :current-page-lot-row="currentPageLots"
          :total-lot-row="totalLots"
          :actif-pk="sendPkLot()"
          :is-program-view="isProgramView"
          :is-lot-view="isLotView"
          :is-parking-list="isParking"
          :loading-source="isLoading"
          @reload="$emit('reload')"
          @deleteElementInList="$emit('deleteElementInList', $event)">
        </lot-row>
      </table>
      <div slot="after-list">
        <div
          v-if="isLoading"
          class="is-w50p has-text-centered is-margin-left-auto is-margin-right-auto">
          <img
            src="/img/loading/spinner2.svg"
            alt="loader">
        </div>
        <div
          v-if="noMoreResult"
          class="is-padding has-text-centered is-margin-left-auto is-margin-right-auto">
          <div class="is-size-7">
            <i>Tous les lots sont affichés.</i>
          </div>
        </div>
      </div>
    </table-controls-vue>
    <div v-if="!loading && !lots.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucun lot à afficher
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import StockMixin from './StockMixin'
import { mapGetters } from 'vuex'
import { Multiselection } from '@/mixins'
// import { downloadXlsFromApi } from '@/utils'

export default {
  name: 'LotList',
  filters: {
    actableStatus (v) {
      let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
      let date = new Date()
      let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
      if (!v) {
        return 'NC'
      } else if (currentTrim > v) {
        return 'Oui'
      } else if (currentTrim <= v) {
        return 'Non'
      }
    }
  },
  components: {
    LotRow: () => import('./LotRow')
  },
  mixins: [StockMixin, Multiselection],
  props: {
    isLoading: Boolean,
    noMoreResult: Boolean,
    isProgramView: Boolean,
    isLotView: Boolean,
    isParking: Boolean,
    isOther: Boolean,
    sourceSortBy: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      displayDetails: false,
      columnsConfResource: 'lots',
      displayRemuneration: true,
      amenagement: false,
      programPk: null,
      dataForExport: [],
      exportLoading: false,
      displaySort: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isDistributeur', 'isManagerPlus']),
    columnsShow () {
      const columns = {}
      if (!this.isProgramView) {
        columns.program__name = { label: 'Programme', mobile: true }
        columns.address__zip_code = { label: 'Code Postal', mobile: true }
        columns.address__city = { label: 'Ville', mobile: true }
        // columns.sale_price_ht = { label: 'Prix de vente HT', mobile: true }
      }
      if (this.isAdmin && this.isDistributeur) {
        columns.promoteur__name = { label: 'Promoteur', mobile: true }
      }
      columns.nature = { label: 'Nature', mobile: true }
      columns.operation_type = { label: 'Type d\'opération', mobile: true }
      columns.lot_type = { label: 'Type', mobile: true }
      columns.lot_subtype = { label: 'Caractéristique', mobile: true }
      columns.tranche = { label: 'Tranche', mobile: true }
      columns.building = { label: 'Bâtiment', mobile: true }
      if (!this.isParking) {
        columns.surface = { label: 'Surface', mobile: true }
        columns.tax_dispositifs = { label: 'Dispositifs', mobile: true }
        columns.rent = { label: 'Loyer', mobile: true }
        columns.profitability = { label: 'Rentabilité', mobile: true }
        columns.capped_profitability = { label: 'Rentabilité Plafonnée', mobile: true }
        columns.floor = { label: 'Étage', mobile: true }
        columns.exposures = { label: 'Orientation', mobile: true }
        columns.parking = { label: 'Parking', mobile: true }
        columns.capped_rent = { label: 'Loyer plafonné', mobile: true }
      }
      if (!this.isLotView && !this.isProgramView) {
        columns.date_livraison = { label: 'Livraison', mobile: true }
        columns.date_actabilite = { label: 'Actabilité', mobile: true }
      }
      columns.created_on = { label: 'Création', mobile: true }
      columns.rent = { label: 'Loyer marché', mobile: true }
      columns.sale_price_ht = { label: 'Prix de vente HT', mobile: true }
      columns.sales_mode = { label: 'Mode de vente', mobile: true }
      columns.options = { label: 'Options', mobile: true }
      return columns
    },
    showSort () {
      if (this.$route.name === 'ProgramLots' || this.$route.name === 'LotVue') {
        return false
      } else {
        return true
      }
    },
    isAmen () {
      if (this.amenagement) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    sourceLots (v) {
      this.updateSources({ lots: v })
      if (this.sendPkLot()) {
        this.$store.dispatch('scrollToLastEl', this.sendPkLot())
      } else {
        this.$store.dispatch('scrollToLastEl')
      }
    },
    'lots' (to) {
      if (to) {
        for (let lot of to) {
          if (lot.program.is_amenagement) {
            this.amenagement = true
            this.programPk = lot.program.pk
          }
        }
      }
    }
  },
  // created () {
  //   this.updateSources
  // },
  methods: {
    sort (name, v) {
      this.$emit('sort', name, v)
    },
    async exportAllLot () {
      this.exportLoading = true
      try {
        const isAmenagement = {
          is_amen: true,
          program: this.programPk
        }
        this.exportXlsFromMultiselect('LOT', 'liste-lots', isAmenagement)
        this.exportLoading = false
      } catch (e) {
        console.log(e)
        this.exportLoading = false
        this.$toasted.global.danger('Erreur lors de la récupération des lots !')
      }
    },
    sendPkLot () {
      if (!this.$route.path.includes('/programmes') && this.$route.meta.parentName === 'LotList') {
        let path = this.$route.path
        let id = path.match(/\/lots\/(.+)/)[1]
        return id
      } else {
        return null
      }
    }
  }
}
</script>
<style lang="sass">
.is_right
  float: right

.container_select_multiple_lotlist
  width: 100%

.select_multiple_lotlist
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_lotlist:hover
  color: white
  text-decoration: none
</style>
